import React from 'react';
import JSZip from 'jszip'
import moment from 'moment';
import TroubleShooting from './TroubleShooting';
import globalLog from '../components/globalLog';
import {browserName, browserVersion, osName, osVersion, isTablet, isIOS, isAndroid} from "react-device-detect";

var logs = ''

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

 /*  componentDidMount() {

    // This is to catch handler, async errors
   /*  window.addEventListener('unhandledrejection', event => {

      console.error('Unhandled promise rejection:', event.reason);

      const { reason, promise } = event;
      const error = reason instanceof Error ? reason : new Error(String(reason));
      const errorInfo = { promise };
      console.debug("reason", reason);

      this.setState({
        hasError: true,
        error,
        errorInfo,
      });

      event.preventDefault();
    });
  } */

  componentDidUpdate() {
    if (logs.length > 200000) {  
      logs = ''
    }
    logs += globalLog.value
  }


  componentDidCatch(error, errorInfo) {

    this.setState({
      hasError: true,
      error: error,
      errorInfo: errorInfo,
    });

    console.debug("Error caught:", error);
    console.debug("Error info:", errorInfo);

    // this.downloadErrorInfo(error, errorInfo, );
  }

  downloadErrorInfo(error, errorInfo) {

    const zip = new JSZip();

    const errorData = {
      error: {
        message: error.message,
        stack: error.stack,
      },
      errorInfo: errorInfo,
      consoleLogs: logs,
      gnbArr: JSON.parse(window.localStorage.getItem('gnbArr')),
      appStates: this.props.appStates,
      others: {
        browserName: browserName ? browserName : "",
        browserVersion: browserVersion ? browserVersion : "",
        osName: osName ? osName : "",
        osVersion: osVersion ? osVersion : "",
        isTablet: isTablet ? isTablet : "",
        isIOS: isIOS ? isIOS : "",
        isAndroid:isAndroid ? isAndroid : "",
      }
    };

    const errorDataJSON = JSON.stringify(errorData, null, 2);


    const fileName = `error_info_${moment().format('MM-DD-YY hh:mm:ss a')}.zip`
    zip.file('error_info.txt', errorDataJSON);

    zip.generateAsync({ type: 'blob', compression: "DEFLATE" })
      .then((blob) => {

        this.downloadBlob(blob, fileName);
      })
      .catch((error) => {
        console.error('Error generating ZIP:', error);
      });

  }

  downloadBlob(blob, filename) {
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = filename;

    a.click();

    window.URL.revokeObjectURL(url);
  }

  render() {
    console.debug("browserName>>??", browserName, browserVersion, osName, osVersion);
    if (this.state.hasError) {
      return (
        <div>
          <h1>Something went wrong.</h1>
          <p>Please download the zip file and email it to <u>support@stemfluency.org</u> </p>
          <button onClick={() => {
            this.downloadErrorInfo(this.state.error, this.state.errorInfo)
          }}>Download error logs</button>

        <div className='mt-4'>
            <TroubleShooting {...this.props} />
        </div>

        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
